
export default{
    // Serveur fournisseur de données - back-end
    hostACF : 'https://gestion.domainethibaut.fr/wp-json/wp/v2/',
    // Routes spécifiques
    host : 'https://gestion.domainethibaut.fr/wp-json/',


    domaineID: 78,
    emailJSserviceContact: '34791k8',
    emailJStemplateContact: 'l4b35xi',
    emailJSkeyContact: 'HFaxlkkjHVsLvQEV5',
    duree_rdv: 15,

    // Jours
        joursSemaineFR: new Array('Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'),
        joursSemaineEN: new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'),

    // Mois
        listeMoisFR: new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'),
        listeMoisEN: new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'),
        
        moisNumeriques: new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'),
        listeMoisReduc: new Array('Janv', 'Fév', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'),

    // Heure
        heureNumerique: new Array('00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'),
        minuteNumeriqueQH: new Array('00', '15', '30', '45'),

    // Alphabet
        alphabetUpper: new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'),
        alphabetLower: new Array('a', 'a', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'),



    // Authentification JWT Wordpress
        // auth : 'http://localhost/wordpress/wp-json/jwt-auth/v1/',
        //   user : 'admin',
        //   psw : 'admin',
   
}




// WEBPACK FOOTER //
// ./src/param/param.js